var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnetAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H17.25V7H12C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17H17.25V22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6V3C22 2.44772 21.5523 2 21 2H18.75V7H21C21.5523 7 22 6.55228 22 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22H18.75V17H21C21.5523 17 22 17.4477 22 18V21C22 21.5523 21.5523 22 21 22Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5303 9.53033C20.8232 9.23744 20.8232 8.76256 20.5303 8.46967C20.2374 8.17678 19.7626 8.17678 19.4697 8.46967L16.4697 11.4697C16.2552 11.6842 16.191 12.0068 16.3071 12.287C16.4232 12.5673 16.6967 12.75 17 12.75H18.1893L16.4697 14.4697C16.1768 14.7626 16.1768 15.2374 16.4697 15.5303C16.7626 15.8232 17.2374 15.8232 17.5303 15.5303L20.5303 12.5303C20.7448 12.3158 20.809 11.9932 20.6929 11.713C20.5768 11.4327 20.3033 11.25 20 11.25H18.8107L20.5303 9.53033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnetAlt);
export default __webpack_public_path__ + "static/media/magnet-alt.6c4317a96ed3a1f036fc4ab611cd3b59.svg";
export { ForwardRef as ReactComponent };